<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">{{newLenderSol ? 'Add Lender Solicitor' : 'Edit Lender Solicitor'}}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
  <form [formGroup]="lenderSolDetails" autocomplete="off">

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Name</label>
        <input class="form-control" maxlength="75" formControlName="name">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Postcode</label>
        <input class="form-control" maxlength="12" formControlName="postcode">
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 1</label>
        <input class="form-control" maxlength="250" formControlName="addressLine1">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 2</label>
        <input class="form-control" maxlength="250" formControlName="addressLine2">
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 3</label>
        <input class="form-control" maxlength="250" formControlName="addressLine3">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 4</label>
        <input class="form-control" maxlength="250" formControlName="addressLine4">
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 5</label>
        <input class="form-control" maxlength="250" formControlName="addressLine5">
      </div>
      <div class="col-sm-6" *ngIf="!newLenderSol">
        <label class="form-label fw-semibold">Active</label>
        <app-yes-no-form-toggle class="d-block" formControlName="isActive"></app-yes-no-form-toggle>
      </div>
    </div>

  </form>
</div>

<div class="modal-footer">
  <ng-container *ngIf="!newLenderSol">
    <button *ngIf="updatingLenderSol" type="button" class="btn btn-success" disabled>
      <span class="spinner-border spinner-border-sm" role="status"></span>
      Updating...
    </button>
    <button *ngIf="!updatingLenderSol" type="button" class="btn btn-success"
      [disabled]="lenderSolDetails.invalid" (click)="saveLenderSol()">Update</button>
  </ng-container>

  <ng-container *ngIf="newLenderSol">
    <button *ngIf="updatingLenderSol" type="button" class="btn btn-success" disabled>
      <span class="spinner-border spinner-border-sm" role="status"></span>
      Saving...
    </button>
    <button type="button" class="btn btn-success" *ngIf="!updatingLenderSol"
      [disabled]="lenderSolDetails.invalid" (click)="addLenderSol()">Save</button>
  </ng-container>
</div>